/* Creazione del check-button per Real Time */
import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Trans } from 'react-i18next';
export default function CheckRealTime(props) {
  const inProps = props
  const [checked, setChecked] = React.useState(inProps.realTime);
  
  const handleChange = (event) => {
    
    setChecked(event.target.checked);
    inProps.callback(event.target.checked);
  };

  return (
    <div className={"checkRealTime"}>
        {/* <FormControlLabel control={
        <Checkbox
        
        size={"small"}
        checked={checked}
        onChange={handleChange}
        color="default"
        inputProps={{ 'aria-label': 'primary checkbox' }}
      />
    } label={<Trans>Real Time</Trans>} /> */}
    </div>)}